let CartSlider = {};

CartSlider = {
    init(event) {
        let $cartSlider = $('.js-cart-related-slider');

        if ($cartSlider.length === 0) {
            return;
        }

        $.each($cartSlider, function () {
			let $slider = $(this);
			let sliderItemLength = $slider.find('.product-thumb-item').length;

            let options = {
                pageDots: false,
                groupCells: false,
                cellAlign: 'center',
                percentPosition: false,
                wrapAround: false,
                contain: true,
				dragThreshold: 10,
				draggable: sliderItemLength > 3 ? true : false,
                prevNextButtons: sliderItemLength > 3 ? true : false,
                on: {
                    ready: function () {
						$slider.removeClass('invisible');
                    },
                },
            };

			$slider.flickity(options);

			if (event == 'destroy') {			
				$slider.flickity('destroy');
				$slider.addClass('invisible');
			}
			
			if (event == 'reInit') {
				$slider.flickity(options);
			}			
        });
    },
}

$(function () {
    CartSlider.init();
});

window.CartSlider = CartSlider;



// WEBPACK FOOTER //
// ./scripts/components/sliders/cart-slider.js